import "./toFirstUpperCase";
import "./dateFormat";



// WEBPACK FOOTER //
// ./src/util/extends/index.js